const stimulusHighlightsActions = {
    types: {
        SECTION_HIGHLIGHTS_SET: 'SECTION_HIGHLIGHTS_SET',
    },

    setStimulusHighlights(stimulusHighlights) {
        return { type: this.types.SECTION_HIGHLIGHTS_SET, stimulusHighlights };
    },
};

export default stimulusHighlightsActions;
